import SettingIcon from "assets/dualicons/setting.svg?react";
import PeopleIcon from "assets/nav-icons/people.svg?react";
import ValidationIcon from "assets/nav-icons/validation.svg?react";
import SwapIcon from "assets/nav-icons/swap.svg?react";
import IdIcon from "assets/nav-icons/id.svg?react";
import UserIcon from "assets/nav-icons/user.svg?react";
import MonitorIcon from "assets/nav-icons/monitor.svg?react";
import LeadStageIcon from "assets/nav-icons/lead-stage.svg?react";
import BadgeIcon from "assets/nav-icons/badge.svg?react";
import CheckDoubleIcon from "assets/nav-icons/check-double.svg?react";
import { NAV_TYPE_GROUP, NAV_TYPE_ITEM } from "constants/app.constant";
import {
  CurrencyRupeeIcon,
} from "@heroicons/react/24/outline";

const ROOT_SETTINGS = "/settings";

const path = (root, item) => `${root}${item}`;

export const settings = {
  id: "settings",
  type: NAV_TYPE_GROUP,
  path: "/settings",
  title: "Settings",
  transKey: "Settings",
  Icon: SettingIcon,
  permissionCode: "STNGSTNGView",
  childs: [
        {
      id: "settings.selection-management",
      type: NAV_TYPE_ITEM,
      path: path(ROOT_SETTINGS, "/selection-management"),
      title: "Selection Management",
      transKey: "Selection Management",
      Icon: SettingIcon,
      permissionCode: "STNGSTNGView",
    },
    {
      id: "settings.appearance",
      type: NAV_TYPE_ITEM,
      path: path(ROOT_SETTINGS, "/appearance"),
      title: "Appearance",
      transKey: "Appearance",
      Icon: MonitorIcon,
      permissionCode: "APRNCEVIEW",
    },
    {
      id: "settings.user-management",
      type: NAV_TYPE_ITEM,
      path: path(ROOT_SETTINGS, "/user-management"),
      title: "User Management",
      transKey: "User Management",
      Icon: PeopleIcon,
      permissionCode: "USRUSRV",
    },
    {
      id: "settings.team-management",
      type: NAV_TYPE_ITEM,
      path: path(ROOT_SETTINGS, "/team-management"),
      title: "Team Management",
      transKey: "Team Management",
      Icon: PeopleIcon,
      permissionCode: "TEAMTMV",
    },
    {
      id: "settings.designation-management",
      type: NAV_TYPE_ITEM,
      path: path(ROOT_SETTINGS, "/designation-management"),
      title: "Designation Management",
      transKey: "Designation Management",
      Icon: BadgeIcon,
      permissionCode: "DESGDSGV",
    },
    {
      id: "settings.template-management",
      type: NAV_TYPE_ITEM,
      path: path(ROOT_SETTINGS, "/template-management"),
      title: "Template Management",
      transKey: "Template Management",
      Icon: SettingIcon,
      permissionCode: "TMPTMPV",
    },

    // {
    //   id: "settings.document-management",
    //   type: NAV_TYPE_ITEM,
    //   path: path(ROOT_SETTINGS, "/document-management"),
    //   title: "Document Management",
    //   transKey: "Document Management",
    //   Icon: SettingIcon,
    //   permissionCode: "STNGSTNGView",
    // },
    {
      id: "settings.lead-stages",
      type: NAV_TYPE_ITEM,
      path: path(ROOT_SETTINGS, "/lead-stages"),
      title: "Lead Stages & Sub-Stages",
      transKey: "Lead Stages & Sub-Stages",
      Icon: LeadStageIcon,
      permissionCode: "LEADSTGSTGV",
    },
    {
      id: "settings.role-permissions",
      type: NAV_TYPE_ITEM,
      path: path(ROOT_SETTINGS, "/role-permissions"),
      title: "Role Permissions",
      transKey: "Role Permissions",
      Icon: ValidationIcon,
      permissionCode: "ROLEROV",
    },
    {
      id: "settings.notification-management",
      type: NAV_TYPE_ITEM,
      path: path(ROOT_SETTINGS, "/notification-management"),
      title: "Notification Management",
      transKey: "Notification Management",
      Icon: SettingIcon,
      permissionCode: "NOTIFSETTINGVIEW",
    },
    {
      id: "settings.rule-management",
      type: NAV_TYPE_ITEM,
      path: path(ROOT_SETTINGS, "/rule-management"),
      title: "Rule Management",
      transKey: "Rule Management",
      Icon: CheckDoubleIcon,
      permissionCode: "RULERV",
    },
    // {
    //   id: "settings.event-score",
    //   type: NAV_TYPE_ITEM,
    //   path: path(ROOT_SETTINGS, "/event-score"),
    //   title: "Company Event Scores",
    //   transKey: "Company Event Scores",
    //   Icon: LeadStageIcon,
    //   permissionCode: "EVNTSCRVIEW",
    // },
    {
      id: "settings.integrations",
      type: NAV_TYPE_ITEM,
      path: path(ROOT_SETTINGS, "/integrations"),
      title: "Integrations",
      transKey: "Integrations",
      Icon: SwapIcon,
      permissionCode: "INTGVIEW",
    },
    // {
    //   id: "settings.paymentCatalogs",
    //   type: NAV_TYPE_ITEM,
    //   path: path(ROOT_SETTINGS, "/payment-catalogs"),
    //   title: "Payment Catalogs",
    //   transKey: "Payment Catalogs",
    //   Icon: CurrencyRupeeIcon,
    //   permissionCode: "PAYCATVIEW",
    // },
    // {
    //     id: 'settings.api-keys',
    //     type: NAV_TYPE_ITEM,
    //     path: path(ROOT_SETTINGS, '/api-keys'),
    //     title: 'API Keys',
    //     transKey: 'API Keys',
    //     Icon: IdIcon,
    // },
    // {
    //     id: 'settings.branding',
    //     type: NAV_TYPE_ITEM,
    //     path: path(ROOT_SETTINGS, '/branding'),
    //     title: 'Branding',
    //     transKey: 'Branding',
    //     Icon: SettingIcon,
    // },
    {
      id: 'settings.tagsSources',
      type: NAV_TYPE_ITEM,
      path: path(ROOT_SETTINGS, "/tags-sources"),
      title: "Tags & Sources",
      transKey: "Tags & Sources",
      Icon: LeadStageIcon,
      permissionCode: "TASVTAS",
    },
    {
      id: 'settings.contactsManagement',
      type: NAV_TYPE_ITEM,
      path: path(ROOT_SETTINGS, "/contacts-management"),
      title: "Contacts",
      transKey: "Contacts",
      Icon: PeopleIcon,
      permissionCode: "CONTVCONT",
    },
    {
      id: 'settings.activityTypes',
      type: NAV_TYPE_ITEM,
      path: path(ROOT_SETTINGS, "/activity-types"),
      title: "Activity Types",
      transKey: "Activity Types",
      Icon: SettingIcon,
      permissionCode: "ACTVACT",
    },
    {
      id: 'settings.profile',
      type: NAV_TYPE_ITEM,
      path: path(ROOT_SETTINGS, '/general'),
      title: 'Profile',
      transKey: 'Profile',
      Icon: UserIcon,
    },
  ],
};
